import TranslatedErrorBoundary from "@/components/ErrorBoundary/errorBoundary.component";
import { ROUTE_LOGIN_OUT } from "@/constants/routes.constants";
import SidebarChats from "@/infrastructure/Sidebar/SidebarChats/sidebarChats.component";
import SidebarModels from "@/infrastructure/Sidebar/SidebarModels/sidebarModels.component";
import SideBarSearch from "@/infrastructure/Sidebar/sidebarSearch.component";
import { Button } from "@/shadcn/components/ui/button";
import { LogOut } from "lucide-react";
import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";

type SidebarProps = {
  currPage: string;
  isSidebarOpen: boolean;
  setIsSidebarOpen: React.Dispatch<React.SetStateAction<boolean>>;
};

const Sidebar: React.FC<SidebarProps> = ({
  currPage,
  isSidebarOpen,
  setIsSidebarOpen,
}) => {
  const { t } = useTranslation();
  const nav = useNavigate();

  return (
    <div
      className={`top-0 left-0 z-50 block h-full w-full flex-shrink-0 bg-black/95 pt-1 transition-all ${
        isSidebarOpen
          ? "absolute translate-x-0 md:relative md:w-[260px]"
          : "absolute w-0 -translate-x-full md:w-0 md:-translate-x-[260px]"
      } [-ms-overflow-style:none] [scrollbar-width:none] [&::-webkit-scrollbar]:hidden`}
    >
      <div className="flex h-full w-full flex-col justify-between p-1 pt-1 md:p-3">
        <TranslatedErrorBoundary>
          <SideBarSearch
            hideSidebar={() => {
              setIsSidebarOpen(false);
            }}
          />
        </TranslatedErrorBoundary>
        <div className="flex h-full w-full flex-col">
          <div className="flex-shrink-0">
            <TranslatedErrorBoundary>
              <SidebarModels
                hideSidebar={() => {
                  setIsSidebarOpen(false);
                }}
              />
            </TranslatedErrorBoundary>
            <div className="divide-opacity-10 bg-opacity-10 my-2 h-[1px] w-full divide-white rounded-md bg-white"></div>
          </div>
          <div className="min-h-0 flex-1">
            <TranslatedErrorBoundary>
              <SidebarChats
                hideSidebar={() => {
                  setIsSidebarOpen(false);
                }}
              />
            </TranslatedErrorBoundary>
          </div>
          <div className="flex-shrink-0">
            <Button
              variant={undefined}
              className={`flex w-full items-center justify-start gap-2 bg-transparent text-left transition-all`}
              onClick={() => {
                nav(ROUTE_LOGIN_OUT);
              }}
            >
              <LogOut className="w-4" />
              {t("Logout")}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Sidebar;
